export enum LanguageType {
    ENGLISH = "ENGLISH",
    FRANCAIS = "FRANCAIS",
    ESPANOL = "ESPANOL",
    NEDERLANDS = "NEDERLANDS",
    ITALIANO = "ITALIANO",
    DEUTSCH = "DEUTSCH",
    ARABIC = "ARABIC",
    HINDI = "HINDI",
    PORTUGUESE = "PORTUGUESE",
}
